/**
 * Offline Message Queue
 *
 * When a user tries to send a chat message while offline, we queue it in
 * localStorage. MessagesPage flushes the queue when the device comes back online.
 *
 * Queue entry shape:
 *   { matchId: string, content: string, queuedAt: number }
 */

const QUEUE_KEY = 'wantd-offline-msg-queue';

/** Add a message to the offline queue */
export function enqueueOfflineMessage(matchId, content) {
  const queue = getQueue();
  queue.push({ matchId, content, queuedAt: Date.now() });
  localStorage.setItem(QUEUE_KEY, JSON.stringify(queue));
}

/** Return all queued messages */
export function getQueue() {
  try {
    return JSON.parse(localStorage.getItem(QUEUE_KEY) || '[]');
  } catch {
    return [];
  }
}

/** Remove messages that have been successfully sent */
export function removeFromQueue(queuedAt) {
  const queue = getQueue().filter((m) => m.queuedAt !== queuedAt);
  localStorage.setItem(QUEUE_KEY, JSON.stringify(queue));
}

/** Clear the entire queue (e.g., on logout) */
export function clearQueue() {
  localStorage.removeItem(QUEUE_KEY);
}
